<template>
  <v-card flat style="background-color:transparent;">
    <p class="ma-0 pa-0">
      <!-- <span class="subtitle-1">{{ new Date() | moment("dddd, MMMM Do YYYY") }}</span> -->
      <span class="title">{{ new Date() | moment("dddd, MMMM Do YYYY") }}</span>
    </p>
    <p class="ma-0 pa-0">
      <v-divider></v-divider>
      <v-divider></v-divider>
    </p>
    
    <v-row>
      <v-col cols="2" class="mt-2">
        <a href="https://www.facebook.com/pages/category/Media-News-Company/WeNewz-332912934271672/" target="_blank" style="text-decoration: none;">
          <v-btn icon medium outlined class="mt-2 ml-1 mr-1" :title="$t('navbar.navbarBig.Link to our Facebook page')">
            <v-icon>fab fa-facebook-f</v-icon>
          </v-btn>
        </a>
      </v-col>

      <v-col cols="5" class="mt-4">
        <v-img src="../erasmusLogo.jpg" aspect-ratio="4"></v-img>
      </v-col>
      <v-col cols="5" class="mt-4">
        <v-img src="/jltLogo.png" aspect-ratio="4" style="background-color: grey;" contain></v-img>
      </v-col>
    </v-row>
    
  </v-card>
</template>

<script>
// i18n imported
import messages from "../../modules/lang/export";
export default {
  // I18n used
  i18n: { messages }
};
</script>
